<template>
  <div class="base-form-div">
    <el-form
      size="mini"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="是否启用">
        <el-switch
          v-model="ruleForm.isUse"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="持续时间(秒)">
        <el-input-number
          controls-position="right"
          :min="1"
          :step="0.5"
          v-model="ruleForm.duration"
        ></el-input-number>
      </el-form-item>
      <div class="form-bottom">
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button class="base-button" size="mini" @click="resetForm('ruleForm')"
          >取消</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ["subData"],
  data() {
    return {
      typeOptions: [],
      ruleForm: {
        isUse: false,
        duration: 3,
      },
      rules: {},
    };
  },
  created() {
    if (this.subData && this.subData.params && this.subData.params.type == "growEntity") {
      this.ruleForm = JSON.parse(JSON.stringify(this.subData.params.data));
    }
  },
  methods: {
    submitForm() {
      this.subData.params.type = "growEntity";
      this.subData.params.data = this.ruleForm;
      this.$parent.close();
    },
    resetForm() {
      this.$parent.close();
    },
  },

  beforeDestroy() {},
};
</script>
<style>
.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
</style>
